// @flow

// $FlowFixMe - require.context is not supported by flow
const requireIcons = require.context('.', false, /.svg/);

export const iconsMap = requireIcons.keys().reduce((icons, filepath) => {
  const iconName = filepath.replace('./', '').replace('.svg', '');
  const iconModule = requireIcons(filepath);
  icons[iconName] = iconModule.default || iconModule;
  return icons;
}, {});
